<template>
    <label
            class="formulate-input-label formulate-input-label--after"
            v-html="context.label"
            for="context.id"
    />
</template>

<script>
    export default {
        props: {
            context: {
                type: Object,
                required: true
            }
        }
    }
</script>